module.exports = __webpack_public_path__ + "static/media/default.641d0768.jpg";